module.exports = __webpack_public_path__ + "img/consult-with-the-doctor-en.6661c99e.png";